import { filaTelepsicologiaConstants } from '../constants';

export function filaTelepsicologia(state = { fila: {} }, action) {
  switch (action.type) {
    case filaTelepsicologiaConstants.FILATPISICOL_SUCCESS:
      return {
        type: 'success',
        fila: action.filaTelepsicologia,
      };
    case filaTelepsicologiaConstants.FILATPISICOL_FAILURE:
      return Object.assign({}, state, {
        type: 'failure',
        fila: [],
      });
    case filaTelepsicologiaConstants.FILATPISICOL_REQUEST:
      return Object.assign({}, state, {
        type: 'request',
        fila: [],
      });
    default:
      console.debug('notification reducer :: hit default', action.type);
      return state;
  }
}
